import React, { type FC, type SVGAttributes } from 'react';

export const ShieldIcon: FC<SVGAttributes<SVGElement>> = props => {
    return (
        <div>
            <svg
                aria-label="Иконка щита"
                fill="none"
                height="24"
                role="img"
                viewBox="0 0 36 36"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path
                    clipRule="evenodd"
                    d="M18 2L2 7.37C4.13 25.12 9.46 34 18 34s13.87-8.88 16-26.63L18 2zm0 31C10 33 5 24.67 3 8.02L18 3l15 5.02C31 24.67 26 33 18 33z"
                    fill="#0B1F35"
                    fillRule="evenodd"
                />
                <path
                    d="M18 5l13 4.33c0 3.14-1.02 7.47-3.07 13C25.9 27.86 22.58 30.75 18 31V5z"
                    fill="#0B1F35"
                    opacity=".3"
                />
            </svg>
        </div>
    );
};
